import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const MuiSelect: {
  defaultProps?: ComponentsProps['MuiSelect'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiSelect'];
  variants?: ComponentsVariants['MuiSelect'];
} = {
  defaultProps: {
    IconComponent: ExpandMoreRounded,
    displayEmpty: true
    // MenuProps: {
    //   autoFocus: false,
    //   anchorOrigin: {
    //     vertical: 'bottom',
    //     horizontal: 'center'
    //   },
    //   transformOrigin: {
    //     vertical: 'top',
    //     horizontal: 'center'
    //   },
    //   slotProps: {
    //     paper: {
    //       elevation: 0,
    //       style: {
    //         boxShadow: 'var(--mui-customShadow-secondary-center)',
    //         borderRadius: '8px',
    //         marginTop: '0.25rem',
    //         maxHeight: 400
    //       }
    //     }
    //   }
    // }
  }
};
